var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 238 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_42)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M236.94 142.063L225.372 45.6284C222.26 19.6647 200.19 0.0785532 174.036 0.0785532H63.55C37.3959 0.0785532 15.3264 19.6647 12.2146 45.6284L0.658729 142.063C-1.09958 156.731 3.5107 171.483 13.3204 182.532C23.118 193.589 37.2176 199.921 51.9941 199.921H185.604C200.369 199.921 214.468 193.589 224.278 182.532C234.076 171.486 238.698 156.734 236.94 142.063ZM205.251 165.773C200 171.689 192.755 174.943 184.858 174.943H52.7433C44.834 174.943 37.5862 171.689 32.3506 165.773C27.0998 159.858 24.7373 152.281 25.6738 144.429L37.0998 49.0755C38.7403 35.3928 50.3778 25.0574 64.1693 25.0574H173.42C187.209 25.0574 198.849 35.3897 200.49 49.0755L211.928 144.429C212.864 152.281 210.487 159.858 205.251 165.773Z",
    fill: "#004956"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.178 112.462C183.359 109.674 180.565 107.761 177.308 107.076C174.045 106.39 170.722 107.015 167.933 108.831C134.668 130.526 102.293 130.523 68.9636 108.828C66.1751 107.012 62.8428 106.387 59.589 107.079C56.3322 107.767 53.5407 109.683 51.725 112.471C49.9093 115.26 49.2869 118.589 49.9757 121.846C50.6645 125.103 52.58 127.894 55.3685 129.71C76.1963 143.269 97.4289 150.142 118.477 150.142C139.529 150.142 160.746 143.266 181.544 129.704C184.332 127.885 186.245 125.091 186.93 121.834C187.619 118.58 186.997 115.251 185.178 112.462Z",
    fill: "#004956"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_42"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 237.462,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoDark);
export default __webpack_public_path__ + "static/media/logo-dark.ef7c50d33f3448ffde1b0180e6c8a3de.svg";
export { ForwardRef as ReactComponent };